import { compose, not, prop, filter, propOf } from 'micro-fp';

import ArchiveGroupCtrl from '../manage/groups/ArchiveGroupCtrl';
import archiveUrl from '../manage/groups/archive.html';
import { groupTexts } from '../manage/constants';

export default class GroupsService {
  constructor(AlertService, ConfirmService, PersonaCollection, pluralizeFilter, $uibModal) {
    'ngInject';

    Object.assign(this, {
      AlertService,
      ConfirmService,
      PersonaCollection,
      pluralizeFilter,
      $uibModal,
    });
  }

  filterArchived = filter(prop('archivedAt'));
  filterUnarchived = filter(compose(not, prop('archivedAt')));

  getSelectedGroups(selectedItemIds, visibleItemsDict, canDeleteGroup) {
    return Object.keys(selectedItemIds)
      .filter(
        (groupId) =>
          selectedItemIds[groupId] && groupId in visibleItemsDict && canDeleteGroup(groupId)
      )
      .map(propOf(visibleItemsDict));
  }

  async archiveGroups(groups, type) {
    const params = await this.$uibModal.open({
      templateUrl: archiveUrl,
      controller: ArchiveGroupCtrl,
      controllerAs: 'ctrl',
      size: '620',
      resolve: {
        groups: () => groups,
      },
    }).result;

    await this.PersonaCollection.archiveGroups(groups, params);
    this.AlertService.success(`${groups.length} ${this.pluralizeFilter(groups, type)} archived`);
  }

  async unarchiveGroups(groups, type) {
    await this.ConfirmService.ask({
      question: groupTexts[type].multipleUnarchive.title,
      conditions: groupTexts[type].multipleUnarchive.conditions,
      title: `Unarchive ${this.pluralizeFilter(groups, type)}`,
      confirm: 'Unarchive',
      type: 'primary',
    });

    await this.PersonaCollection.unarchiveGroups(groups);
    this.AlertService.success(`${groups.length} ${this.pluralizeFilter(groups, type)} unarchived`);
  }
}
